import { useState, ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { SkipToMainContent } from "./SkipToMainContent";

interface DashboardLayoutProps {
  children: ReactNode;
  hideHeader?: boolean;
  /** SplitMage mini-app: tighter padding (same white canvas as other dashboard pages). */
  immersive?: boolean;
}

/**
 * Dashboard Layout.
 */
export function DashboardLayout({
  children,
  hideHeader = false,
  immersive = false,
}: Readonly<DashboardLayoutProps>) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div
      className="flex min-h-screen w-full max-w-none bg-white"
      data-menu-open={isMenuOpen ? "true" : "false"}
      data-immersive={immersive ? "true" : undefined}
    >
      <SkipToMainContent />
      <Sidebar setIsMenuOpen={setIsMenuOpen} />
      <div className="flex flex-col flex-1 w-full max-w-none min-h-screen min-w-0 overflow-x-hidden">
        {!hideHeader && <Header />}
        <main
          id="main-content"
          tabIndex={-1}
          className={
            immersive
              ? "flex-1 px-3 py-2 sm:p-4 lg:p-5 w-full max-w-none min-w-0 outline-none"
              : "flex-1 p-4 sm:p-6 lg:p-8 w-full max-w-none min-w-0 outline-none"
          }
        >
          <div
            className={
              immersive
                ? "w-full max-w-none min-w-0 space-y-4 sm:space-y-5"
                : "w-full max-w-none min-w-0 space-y-6 sm:space-y-8"
            }
          >
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
